export class SessionTimeOutError extends Error {
}
